<template>
    <div class="part" v-loading="loading">
        <div class="layout-page-box">
            <el-form :inline="true" label-position="right" class="search-form">
                <el-form-item label="院区">
                    <el-select clearable v-model="filters.earId" placeholder="选择院区" multiple>
                        <el-option v-for="(item) in areaOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="初/复诊">
                    <el-select clearable v-model="filters.status" placeholder="选择初/复诊" multiple>
                        <el-option v-for="(item) in statusOptions" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="划扣项目">
                    <el-select ref='mySelected' @focus="focus(3)" clearable v-model="filters.musProjectNameId" placeholder="选择划扣项目" filterable :filter-method="projectMatch" multiple>
                        <el-option v-for="(item) in projectList" :key="item.id" :label="item.project" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="购买项目">
                    <el-select @focus="focus(3)" clearable v-model="filters.projectId" placeholder="选择购买项目" filterable :filter-method="projectMatch" multiple>
                        <el-option v-for="(item) in projectList" :key="item.id" :label="item.project" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="楼层">
                    <el-select @focus="focus('lc')" clearable v-model="filters.sknFloor" placeholder="选择楼层" multiple>
                        <el-option v-for="(item) in floorOptions" :key="item.id" :label="item.floorName" :value="item.floorName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="门诊号">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('cadCode')" @change.capture.native="onInput($event,'cadCode')" :popper-append-to-body="false" clearable v-model="filters.cadCode" placeholder="请输入门诊号" multiple allow-create filterable default-first-option></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="耗材名称">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('materialName')" @change.capture.native="onInput($event,'materialName')" :popper-append-to-body="false" clearable v-model="filters.materialName" placeholder="请输入耗材名称" multiple allow-create filterable default-first-option></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="姓名">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('sknName')" @change.capture.native="onInput($event,'sknName')" :popper-append-to-body="false" clearable v-model="filters.sknName" placeholder="请输入姓名" multiple filterable allow-create></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="手机号">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('mobile')" @change.capture.native="onInput($event,'mobile')" :popper-append-to-body="false" clearable v-model="filters.mobile" placeholder="请输入手机号" multiple allow-create filterable default-first-option></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="医生">
                    <el-select @focus="focus(1)" :filter-method="doctorMatch" filterable remote clearable v-model="filters.doctorName" placeholder="选择医生" multiple>
                        <el-option v-for="(item) in newList1" :key="item.id" :label="item.identityName" :value="item.identityName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="护士">
                    <el-select @focus="focus(2)" :filter-method="bbMatch" filterable remote clearable v-model="filters.nurseName" placeholder="选择护士" multiple>
                        <el-option v-for="(item) in newList2" :key="item.id" :label="item.identityName" :value="item.identityName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="录入人">
                    <el-select @focus="focus(4)" clearable v-model="filters.createBy" placeholder="选择录入人" multiple>
                        <el-option v-for="(item) in manList" :key="item.id" :label="item.userName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="layout-page-box" v-loading="tableload">
            <el-table :height="tableHeight" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" v-horizontal-scroll="'always'">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="sknDate" label="日期" fixed width="100"></el-table-column>
                <el-table-column prop="sknName" label="姓名" fixed width="80"></el-table-column>
                <el-table-column prop="cadCode" label="门诊号" fixed width="120"></el-table-column>
                <el-table-column prop="status" label="初/复诊" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==1">初诊</span>
                        <span v-if="scope.row.status==2">复诊</span>
                        <span v-if="scope.row.status==3">再消费</span>
                        <span v-if="scope.row.status==4">复查</span>
                        <span v-if="scope.row.status==5">其他</span>
                    </template>
                </el-table-column>
                <el-table-column prop="caseCode" label="病历号" width="110"></el-table-column>
                <el-table-column prop="flag" label="客户标签" width="80"></el-table-column>
                <el-table-column prop="sex" label="性别" width="80"></el-table-column>
                <el-table-column prop="age" label="年龄" width="80"></el-table-column>
                <el-table-column prop="mobile" label="电话" width="150">
                    <template slot="header">
                        <span>电话</span>
                        <el-button style="margin-left:10px;" v-permission="'90'" @click="show" class="filter-item" type="success" size="mini" icon="el-icon-view"></el-button>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="mobileHiding==true">{{scope.row.mobile}}</span>
                        <span v-if="mobileHiding==false">
                            <div v-for="(item,index) in scope.row.mobile.split('/')" :key='index'>{{item.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2")}}</div>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="informationSource" label="信息来源"></el-table-column>
                <el-table-column prop="projectName" label="购买项目" width="160">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.projectName!=' '">{{item.projectName}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="projectReplenish" label="项目补充" width="150">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.projectReplenish!=' '">{{item.projectReplenish}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="purchaseNumber" label="疗程购买次/支">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.purchaseNumber!=' '">{{item.purchaseNumber}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="projectAmt" label="疗程收费">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.projectAmt!=' '">{{item.projectAmt}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="musProjectName" label="当日划扣项目" width="120">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.musProjectName!=' '">{{item.musProjectName}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="musAmt" label="当日划扣金额">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.musAmt!=' '">{{item.musAmt}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="musContent" label="划扣次数">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.musContent!=' '">{{item.musContent}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="musCode" label="划扣卡号" width="150">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.musCode!=' '">{{item.musCode}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="rnCount" label="剩余次数">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.rnCount!=' '">{{item.rnCount}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column prop="remark" label="备注" width="120">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.remark!=' '">{{item.remark}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="materialName" label="耗材名称" width="180">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.materialName!=' '">{{item.materialName}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="materialSpec" label="耗材规格" width="120">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.materialSpec!=' '">{{item.materialSpec}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="manufacturers" label="耗材厂家">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.manufacturers!=' '">{{item.manufacturers}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="number" label="数量">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.number!=' '">{{item.number}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="actualUse" label="实际使用">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.actualUse!=' '">{{item.actualUse}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="empName" label="咨询师"></el-table-column>
                <el-table-column prop="doctorName" label="医生">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.doctorName!=' '">{{item.doctorName}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="aideName" label="医助">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.aideName!=' '">{{item.aideName}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="nurseName" label="护士">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.nurseName!=' '">{{item.nurseName}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="projectRemark" label="产品备注"></el-table-column>
                <el-table-column prop="earName" label="院区"></el-table-column>
                <el-table-column prop="sknFloor" label="楼层"></el-table-column>
                <el-table-column prop="injectionProjectName" label="注射项目名称">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.injectionProjectName!=' '">{{item.injectionProjectName}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="injectionNurseName" label="送诊护士">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.list" :key="index">
                            <span v-if="item.injectionNurseName!=' '">{{item.injectionNurseName}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createBy" label="录入人" width="100"></el-table-column>
                <el-table-column prop="createTime" label="录入时间" width="100"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import permission from '../../directives/permission/index'
import { v4 as uuidv4 } from "uuid";
import { log } from 'util';
export default {
    directives: {
        permission
    },
    name: "list",
    computed: {
        ...mapState(['statusOptions', 'areaOptions']),
        ...mapGetters(['list1', 'list2', 'productOptions', 'createByList', 'areaAndFloorList']),
    },
    data() {
        return {
            formData: {},
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
                musProjectName: [],
                project: [],
            },
            tableData: [],
            multipleSelection: [],
            loading: false,
            dialogForm: false,
            form: {},
            dialog: false,
            newList1: [],
            newList2: [],
            empty: [],
            projectList: [],
            manList: [],
            floorOptions: [],
            rowId: '',
            tableload: false,
            inputName: '',
            inputCode: "",
            inputmater: "",
            inputMobile: "",
            jurisdictionId: Lockr.get("skinJurisdictionId"),
            empId: Lockr.get("skinEmpId"),
            s: [],
            mobileHiding: false,
            tableHeight: '',
        }
    },
    methods: {
        show() {
            this.mobileHiding = !this.mobileHiding
        },
        transformTime() {
            const d = new Date();
            let y = d.getFullYear();
            let m = d.getMonth() + 1;
            let s = d.getDate();
            let h = d.getHours();
            let k = d.getMinutes();
            let l = d.getSeconds();
            if (m < 10) m = "0" + m;
            if (s < 10) s = "0" + s;
            if (h < 10) h = "0" + h;
            if (k < 10) k = "0" + k;
            if (l < 10) l = "0" + l;
            const datetime = y + "-" + m + "-" + s + " " + h + ":" + k + ":" + l;
            return datetime;
        },
        // 获取时间差
        getIntervalHour(dt1, dt2) {
            if (typeof (dt1) == "string") {
                dt1 = new Date(dt1.replace(/-/, '/'));
                dt2 = new Date(dt2.replace(/-/, '/'));
            }
            var res = dt2 - dt1;
            if (isNaN(res))
                throw Error("invalid dates arguments");
            return res / (1000 * 60 * 60);
        },
        getArr(arr) {
            // 获取每一项下的楼层数组
            let time = arr.map(val => {
                return val.floorNameList
            })
            // 二维数组转一维数组
            let newArr = time.flat();
            // 数组去重
            let obj = {};
            newArr = newArr.reduce((cur, next) => {
                obj[next.floorName] ? "" : obj[next.floorName] = true && cur.push(next);
                return cur;
            }, [])
            return newArr
        },
        focus(val) {
            if (val == 1) {
                this.newList1 = this.list1
            } else if (val == 2) {
                this.newList2 = this.list2
            } else if (val == 3) {
                this.projectList = this.productOptions
            } else if (val == 4) {
                this.manList = this.createByList
            } else if (val == 'lc') {
                let newArr = this.getArr(this.areaAndFloorList)
                // 给楼层对象赋值
                this.floorOptions = newArr
            }
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        // 查询数据列表
        query(page) {
            this.tableload = true
            this.filters.musProjectName = []
            this.filters.project = []
            this.projectList.forEach(item => {
                // 获取划扣项目选中的名称
                this.filters.musProjectNameId.forEach(ele => {
                    if (ele == item.id) {
                        this.filters.musProjectName.push(item.project)
                    }
                });
                // 获取选中购买项目名称的name
                this.filters.projectId.forEach(val => {
                    if (val == item.id) {
                        this.filters.project.push(item.project)
                    }
                });
            });
            var querys = {
                earId: this.filters.earId.toString(),
                status: this.filters.status.toString(),
                cadCode: this.filters.cadCode.toString(),
                sknFloor: this.filters.sknFloor.toString(),
                mobile: this.filters.mobile.toString(),
                createBy: this.filters.createBy.toString(),
                musProjectNameId: this.filters.musProjectNameId.toString(),
                musProjectName: this.filters.musProjectName.toString(),
                projectId: this.filters.projectId.toString(),
                project: this.filters.project.toString(),
                doctorName: this.filters.doctorName.toString(),
                nurseName: this.filters.nurseName.toString(),
                materialName: this.filters.materialName.toString(),
                sknName: this.filters.sknName.toString(),
                page: page,
                size: this.filters.pagination.limit,
                startTime: '',
                endTime: '',
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            // console.log(querys)
            api.request('/skn/findPastRecordsSknMaterialList', querys, (res) => {
                // console.log(res)
                if (res.result == true) {
                    var data = res.data.list
                    this.tableData = data
                    this.filters.pagination.total = parseInt(res.data.count)
                    this.tableload = false
                    this.tableData.forEach(ele => {
                        ele.hour = this.getIntervalHour(ele.createTime, this.transformTime())
                        // 判断编辑权限、超过48小时无法编辑、管理员可以修改导入的历史数据
                        if (this.jurisdictionId != 1) {
                            if (ele.createBy == '') {
                                ele.disabled = true
                            } else {
                                if (ele.hour >= 48) {
                                    ele.disabled = true
                                } else {
                                    ele.disabled = false
                                }
                            }
                        }
                        let reg = new RegExp('，', 'g')//g代表全部
                        ele.mobile = (ele.mobile).replace(reg, '/');
                    });
                }
            })
        },
        // 导出皮肤科消费列表
        skin() {
            this.common("skn/excelSknMaterialList", "皮肤科消费列表.xlsx", false)
        },
        // 调整核算成本
        reset() {
            this.common("skn/excelSknMaterialList", "调整核算成本列表.xlsx", true)
        },
        // 导出业绩表
        exp() {
            this.common("skn/excelSknPerformanceList", "皮肤科业绩表.xlsx", '')
        },
        // 导出全年表
        all() {
            this.common("skn/excelSknAnnualList", "皮肤科全年表.xlsx", '')
        },
        common(commonUrl, title, adjust) {
            let exportUrl = axios.defaults.baseURL;
            this.filters.musProjectName = []
            this.filters.project = []
            this.projectList.forEach(item => {
                // 获取划扣项目选中的名称
                this.filters.musProjectNameId.forEach(ele => {
                    if (ele == item.id) {
                        this.filters.musProjectName.push(item.project)
                    }
                });
                // 获取选中购买项目名称的name
                this.filters.projectId.forEach(val => {
                    if (val == item.id) {
                        this.filters.project.push(item.project)
                    }
                });
            });
            var register = {
                total: this.filters.pagination.total,
                startTime: '',
                endTime: "",
                earId: this.filters.earId.toString(),//院区
                status: this.filters.status.toString(),//分诊状态
                cadCode: this.filters.cadCode.toString(),//客户卡号（门诊号）
                sknFloor: this.filters.sknFloor.toString(),//楼层
                mobile: this.filters.mobile.toString(),//电话
                createBy: this.filters.createBy.toString(),//创建人
                musProjectNameId: this.filters.musProjectNameId.toString(),//划扣项目
                musProjectName: this.filters.musProjectName.toString(),
                projectId: this.filters.projectId.toString(),//购买项目
                project: this.filters.project.toString(),
                doctorName: this.filters.doctorName.toString(),//医生
                nurseName: this.filters.nurseName.toString(),//护士
                materialName: this.filters.materialName.toString(),//耗材
                sknName: this.filters.sknName.toString(),//姓名
                adjust: adjust,//调整核算成本
                createById: this.empId,
            }
            if (this.filters.startTime) {
                register.startTime = this.filters.startTime[0]
                register.endTime = this.filters.startTime[1]
            }
            var formData = new FormData();
            formData.append("information", JSON.stringify(register))
            this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.loading = true;
                    axios
                        .post(
                            exportUrl + commonUrl, formData, {
                                responseType: "blob",
                            }
                        )
                        .then((res) => {
                            console.log(res)
                            const blob = new Blob([res.data], {
                                type: "application/vnd.ms-excel",
                            });
                            // console.log(blob, '----------0990');
                            const fileName = title;
                            const linkNode = document.createElement("a");
                            linkNode.download = fileName; //a标签的download属性规定下载文件的名称
                            linkNode.style.display = "none";
                            linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
                            document.body.appendChild(linkNode);
                            linkNode.click(); //模拟在按钮上的一次鼠标单击
                            URL.revokeObjectURL(linkNode.href); // 释放URL 对象
                            document.body.removeChild(linkNode);
                            this.loading = false;
                        });
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        doctorMatch(val) {
            this.newList1 = _g.paramMatch(this.list1, this.newList1, val, 'identityName')
        },
        bbMatch(val) {
            this.newList2 = _g.paramMatch(this.list2, this.newList2, val, 'identityName')
        },
        projectMatch(val) {
            this.projectList = _g.paramMatch(this.productOptions, this.projectList, val, 'project')
        },
        // 姓名多选款
        onBlur(val) {
            if (val == 'sknName') {
                if (this.inputName != '' && !this.filters.sknName.includes(this.inputName)) {
                    this.filters.sknName.push(this.inputName)
                }
            } else if (val == 'materialName') {
                if (this.inputmater != '' && !this.filters.materialName.includes(this.inputmater)) {
                    this.filters.materialName.push(this.inputmater)
                }
            } else if (val == 'cadCode') {
                if (this.inputCode != '' && !this.filters.cadCode.includes(this.inputCode)) {
                    this.filters.cadCode.push(this.inputCode)
                }
            } else if (val == 'mobile' && !this.filters.mobile.includes(this.inputMobile)) {
                if (this.inputMobile != '') {
                    this.filters.mobile.push(this.inputMobile)
                }
            }
        },
        onInput(index, val) {
            if (index.target.value != '') {
                if (val == 'sknName') {
                    this.inputName = index.target.value
                } else if (val == 'materialName') {
                    this.inputmater = index.target.value
                } else if (val == 'cadCode') {
                    this.inputCode = index.target.value
                } else if (val == 'mobile') {
                    this.inputMobile = index.target.value
                }
            }
        },
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 310
    },
    mounted() {
        this.$store.dispatch('getIdList')
        this.query(this.filters.pagination.page)
    },
    watch: {
        '$route'(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        }
    }
}
</script>

<style scoped>
@import "../../assets/css/main.css";
.part >>> .el-table .el-table__cell {
  padding: 0 !important;
  box-sizing: border-box;
}
.all >>> .el-dialog {
  width: 90% !important;
}
.all >>> .el-dialog__body {
  padding: 0px 20px !important;
}
.all >>> .el-dialog__header {
  padding-top: 0px !important;
}
.no >>> .el-select-dropdown {
  display: none;
}
.filebox {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;
  left: 0;
  top: 0;
}
.updatekc {
  position: relative;
  cursor: pointer;
}
.part >>> .el-button i {
  margin-right: 0px !important;
}
</style>